import React from "react"
import { graphql } from "gatsby"
import { SemestersYaml } from "../../types/graphql-types"
import moment, { Moment } from "moment"
import "moment/locale/de"

moment.locale("de")

export const semestersQuery = graphql`
  fragment Semesters on SemestersYaml {
    id
    name
    start
    end
  }
`

const mpz = (s: string): Moment => moment.parseZone(s, "DD.MM.YYYY")

export const semestersOrder = (a: SemestersYaml, b: SemestersYaml): number => {
  const ma = mpz(a?.start)
  const mb = mpz(b?.start)
  return ma.isBefore(mb, "day") ? -1 : ma.isSame(mb, "day") ? 0 : 1
}

export const reverseSemestersOrder = (
  a: SemestersYaml,
  b: SemestersYaml
): number => semestersOrder(b, a)

export const isCurrentSemester = (s: SemestersYaml): boolean =>
  moment().isBetween(mpz(s?.start), mpz(s?.end), "day", "[]")

export const isOutdatedSemester = (s: SemestersYaml): boolean =>
  moment().isAfter(mpz(s?.end), "day")

export const isFutureSemester = (s: SemestersYaml): boolean =>
  moment().isBefore(mpz(s?.start), "day")

export const isSameOrAfterSemester = (
  s: SemestersYaml,
  t: SemestersYaml
): boolean => moment(mpz(s?.start)).isSameOrAfter(mpz(t?.start), "day")

export const SemesterHeading: React.FC<{ semester: SemestersYaml }> = ({
  semester,
}) => (
  <div className="pt-4">
    <h2 className="text-2xl lg:text-3xl inline-block">{semester.name}</h2>
  </div>
)
